export enum PostListingType {
  Full,
  Preview,
}
